export var FS_MEAL_RESTRICTIONS = 'NEXT_FS_MEAL_RESTRICTIONS';
export var FS_ENABLE_SEARCH_ACCOUNT_SAVE_CHANGES = 'NEXT_FS_ENABLE_SEARCH_ACCOUNT_SAVE_CHANGES';
export var FS_DISPLAY_GUEST_ACCOUNT = 'NEXT_FS_DISPLAY_GUEST_ACCOUNT';
export var FS_CONFIRM_EMAIL_ADDRESS_CCUI = 'NEXT_FS_CONFIRM_EMAIL_ADDRESS_CCUI';
export var FS_SHOW_AMEND_PAYMENT_PAGE = 'NEXT_FS_SHOW_AMEND_PAYMENT_PAGE';
export var FS_DISPLAY_REGISTER_GDP = 'NEXT_PUBLIC_DISPLAY_REGISTER_GDP';
export var FS_ENABLE_AMEND_PAY_NOW_PI_BB = 'NEXT_ENABLE_AMEND_PAY_NOW_PI_BB';
export var FS_ENABLE_APPLEPAY_GOOGLEPAY = 'NEXT_PUBLIC_APPLEPAY_GOOGLEPAY_ENABLE';
export var FS_ENABLE_SEO_BREADCRUMB_PI = 'NEXT_FS_SEO_BREADCRUMB_PI';
export var FS_ENABLE_META_ARRIVAL_DAY_KEYWORD_PI = 'NEXT_FS_META_ARRIVAL_DAY_KEYWORD_PI';
export var FS_SILENT_SUBSTITUTION = 'NEXT_FS_SILENT_SUBSTITUTION';
export var FS_ENABLE_AMAZON_CHAT = 'NEXT_PUBLIC_AMAZON_CHAT_ENABLED';